import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageSectionHeading from '../../PageSectionHeading';
import CommunityMap from '../../CommunityMap';
import HomeMap from '../../HomeMap';
// import { colors } from '../../../styles';

const styles = css`
  padding: 45px 0;
  text-align: center;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .TabMenu {
    margin: 0 0 30px 0;
    @media (min-width: 992px) {
      margin: 0 0 60px 0;
    }
  }
`;

class ProductMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: (undefined),
    };
  }

  switchTabHandler = tab => {
    this.setState({
      tab,
    });
  }

  render() {
    const { content } = this.props;
    const { tab = get(content, '[0].hide_communities') ? 'homes' : 'communities' } = this.state;
    return (
      <div className={styles}>
        {
          get(content, '[0].section_heading') &&
          <PageSectionHeading h3={get(content, '[0].section_heading')} />
        }
        {
          !get(content, '[0].hide_communities') && !get(content, '[0].hide_homes') &&
          <div className="TabMenu">
            <button
              onClick={() => this.switchTabHandler('communities')}
              tabIndex={0}
              className={`tab ${tab === 'communities' ? 'active' : ''}`}
            >
              Communities
            </button>
            <button
              onClick={() => this.switchTabHandler('homes')}
              tabIndex={0}
              className={`tab ${tab === 'homes' ? 'active' : ''}`}
            >
              Available Homes
            </button>
          </div>
        }
        {
          (!get(content, '[0].hide_communities') && tab === 'communities') &&
          <div>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <CommunityMap />
                </div>
              </div>
            </div>
          </div>
        }
        {
          (!get(content, '[0].hide_homes') && tab === 'homes') &&
          <div>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <HomeMap />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

ProductMap.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ProductMap;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ProductMap.section.js